const LOCAL_STORAGE_KEYS = {
    STORE_LOCAL_BUSINESS_ACCOUNT_DRAFT: 'state::localBusinessAccountDraft',
    CURRENT_BUSINESS_ACCOUNT_ID: 'currentBusinessAccountId',
    CURRENT_CENTRAL_ORGANISATION_ID: 'currentCentralOrganisationId',
    ACCESS_TOKEN: 'accessToken',
    REFRESH_TOKEN: 'refreshToken',
    ALLOWED_SIGN_UP_STEPS: 'allowedSignUpSteps',
    RECEIPT_BULK_DOWNLOAD_OPERATION_ID: 'receiptBulkDownloadOperationId',
    SIGN_UP_TRACKING_PARAMS: 'signUpTrackingParams',
    FORCE_ZENDESK_CHAT_ENABLED: 'forceZendeskChatEnabled',
};

export default LOCAL_STORAGE_KEYS;
